import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChecklistService } from 'src/app/pages/checklist/services/checklist.service';

@Component({
  selector: 'app-create-new-checklist-modal',
  templateUrl: './create-new-checklist-modal.component.html',
  styleUrls: ['./create-new-checklist-modal.component.css'],
})
export class CreateNewChecklistModalComponent implements OnInit {
  @Input() mode: any;
  mobileMode = false;
  formData: { [key: string]: any } = {};
  templates: any[] = [];
  templateCategoryIDs: { [key: string]: number } = { C: 1, O: -1, P: -2, H: -4 };

  constructor(
    private activeModal: NgbActiveModal,
    private utilityService: UtilityService,
    private checklistService: ChecklistService
  ) {
    this.mobileMode = this.utilityService.isMobileMode();
  }

  ngOnInit(): void {
    this.utilityService.openModal();
    this.getTemplateCategories();
  }

  getTemplateCategories() {
    this.checklistService.getTemplateCategories(this.templateCategoryIDs[this.mode]).then((response: any) => {
      if (response != null && response.length > 0) {
        response.forEach((val: any) => {
          if (
            val.ChecklistTemplateIsActive &&
            ((this.mode == 'C' && val.ChecklistTemplateCatgID == 1) || (this.mode == 'H' && val.ChecklistTemplateCatgID == -4))
          )
            this.templates.push({
              DisplayValue: val.ChecklistTemplateCatgName + ' - ' + val.ChecklistTemplateName,
              ChecklistTemplateID: val.ChecklistTemplateID,
            });
        });
        if (this.templates != null && this.templates.length > 0) {
          this.formData.selectedTemplate = this.templates[0].ChecklistTemplateID;
        }
        this.utilityService.closeModal();
      } else {
        this.utilityService.closeModal();
      }
    });
  }

  createClicked() {
    this.activeModal.close(this.formData.selectedTemplate);
  }

  cancelClicked() {
    this.activeModal.close('cancel');
  }
}
